import React, { MouseEvent } from 'react';
import { jss } from '../tools/jss';
import { mui } from '../tools/mui';
import { NavLink } from 'react-router-dom';

interface NavItemProps {
  url?: string;
  label: string;
  'data-testid'?: string;
  visible?: boolean;
  onClick?: () => void;
}

const useStyles = jss.makeStyles((theme) => {
  return {
    listItem: {
      display: 'block',
      padding: 0,
    },
    navLink: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      outline: 0,
      textDecoration: 'none',
      color: 'black',
      '&:hover': {
        // @ts-ignore @TODO Epic WT-21600
        background: theme.palette.gray6,
      },
      '&:active, &:focus': {
        fontWeight: 'bold',
      },
      padding: '0 0 0 16px',
      height: '40px',
      borderRadius: '20px 0px 0px 20px',
    },
    navItemText: {
      flex: 'none',
    },
    selected: {
      // @ts-ignore @TODO Epic WT-21600
      background: theme.palette.gray6,
      '&:hover': {
        // @ts-ignore @TODO Epic WT-21600
        background: theme.palette.gray6,
      },
      '& .MuiTypography-root': {
        fontWeight: 'bold',
      },
    },
  };
});

const NavItem: React.FC<NavItemProps> = ({
  url = '',
  label = '',
  'data-testid': dataTestId = '',
  visible = true,
  onClick = null,
}) => {
  const styles = useStyles();
  const testLabel = dataTestId || label;

  const handleClick = (event: MouseEvent) => {
    if (onClick !== null) {
      onClick();
    }
  };

  if (!visible) return null;

  return (
    <mui.ListItem className={styles.listItem}>
      <NavLink
        to={url}
        onClick={handleClick}
        className={({ isActive }) => jss.combineStyles(styles.navLink, { [styles.selected]: isActive && !!url })}
        data-testid={testLabel}
      >
        <mui.ListItemText className={styles.navItemText} primary={label} />
      </NavLink>
    </mui.ListItem>
  );
};

export default NavItem;
